import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	Alignment,
	Button,
	Classes,
	Dialog,
	FormGroup,
	InputGroup,
	Intent,
	Navbar,
	NumericInput,
} from '@blueprintjs/core';

import TextWithTooltip from '../TextWithTooltip';
import { AppToaster }  from '../AppToaster';

class AddEditActivity extends Component {
	constructor(props) {
		super(props);
		
		this.state = {
			id_activity:      props.item === null ? -1        : props.item.id_activity,
			title:            props.item === null ? ''        : props.item.title,
			ord:              props.item === null ? 1         : props.item.ord,
			color_foreground: props.item === null ? '#000000' : props.item.color_foreground,
			color_background: props.item === null ? '#ffffff' : props.item.color_background,
			validation_failed_fields: [],
		};
	}
	
	render() {
		return <Dialog
			isOpen={true}
			usePortal={true}
			canOutsideClickClose={true}
			canEscapeKeyClose={true}
			onClose={() => this.props.closeAddEditItemDialog()}
			className='add-edit-activity-dialog'>
			<div className='flex flex-col flex-grow'>
				<Navbar fixedToTop={false} className='bp5-dark'>
					<Navbar.Group>
						<Navbar.Heading>Dodaj / uredi aktivnost</Navbar.Heading>
					</Navbar.Group>
					<Navbar.Group align={Alignment.RIGHT}>
						<Button minimal={true} icon='cross' onClick={() => this.props.closeAddEditItemDialog()} />
					</Navbar.Group>
				</Navbar>
				<div className={Classes.DIALOG_BODY}>
					<div className='flex flex-1 flex-col'>
						<FormGroup
							labelFor='add-edit-activity-dialog--title'
							className={
								'flex-1 ' +
								(this.state.validation_failed_fields.indexOf('title') == -1 ?
									'' : 'validation-failed')
							}>
							<TextWithTooltip
								label='Naziv'
								tooltip='Naziv' />
							<InputGroup
								id='add-edit-activity-dialog--title'
								value={this.state.title}
								onChange={event => {
									this.setState({
										title: event.target.value,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-activity-dialog--ord'
							className='flex-1'>
							<TextWithTooltip
								label='Vrstni red'
								tooltip='Vrstni red' />
							<NumericInput
								id='add-edit-activity-dialog--ord'
								value={this.state.ord}
								min={0}
								minorStepSize={1}
								onValueChange={val => {
									this.setState({
										ord: val,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-activity-dialog--color_foreground'
							className={
								'flex-1 ' +
								(this.state.validation_failed_fields.indexOf('color_foreground') == -1 ?
									'' : 'validation-failed')
							}>
							<TextWithTooltip
								label='Barva'
								tooltip='Barva' />
							<InputGroup
								id='add-edit-activity-dialog--color_foreground'
								value={this.state.color_foreground}
								onChange={event => {
									this.setState({
										color_foreground: event.target.value,
									});
								}} />
						</FormGroup>
						<FormGroup
							labelFor='add-edit-activity-dialog--color_background'
							className={
								'flex-1 ' +
								(this.state.validation_failed_fields.indexOf('color_background') == -1 ?
									'' : 'validation-failed')
							}>
							<TextWithTooltip
								label='Barva (ozadje)'
								tooltip='Barva (ozadje)' />
							<InputGroup
								id='add-edit-activity-dialog--color_background'
								value={this.state.color_background}
								onChange={event => {
									this.setState({
										color_background: event.target.value,
									});
								}} />
						</FormGroup>
					</div>
				</div>
				<div className={Classes.DIALOG_FOOTER}>
					<div className={Classes.DIALOG_FOOTER_ACTIONS}>
						<Button
							minimal={true}
							onClick={() => this.props.closeAddEditItemDialog()}>
							Prekliči
						</Button>
						<Button
							intent={Intent.PRIMARY}
							onClick={() => {
								const new_item = {
									id_activity:          this.state.id_activity,
									title:                this.state.title,
									ord:                  this.state.ord,
									color_foreground:     this.state.color_foreground,
									color_background:     this.state.color_background,
									serial_internal_code: this.props.item === null ? null : this.props.item.serial_internal_code,
								};
								
								// validate missing/empty fields
								const validation_failed_fields       = [];
								const validation_failed_field_titles = [];
								
								if (new_item.title.length == 0) {
									validation_failed_fields.push('title');
									validation_failed_field_titles.push('naziv');
								}
								if (new_item.color_foreground.length == 0) {
									validation_failed_fields.push('color_foreground');
									validation_failed_field_titles.push('barva');
								}
								if (new_item.color_background.length == 0) {
									validation_failed_fields.push('color_background');
									validation_failed_field_titles.push('barva (ozadje)');
								}
								
								this.setState({ validation_failed_fields });
								
								if (validation_failed_fields.length > 0) {
									AppToaster.show({
										message: <div>
											Za shranjevanje, izpolnite vsaj polja:
											<br />
											{validation_failed_field_titles.map(title => <div key={title}>{'• ' + title}</div>)}
										</div>,
										intent: 'danger',
										icon: 'issue'
									});
									return;
								}
								
								// save item
								this.props.closeAddEditItemDialog(new_item);
							}}>
							Shrani in zapri
						</Button>
					</div>
				</div>
			</div>
		</Dialog>;
	}
}
AddEditActivity.propTypes = {
	closeAddEditItemDialog: PropTypes.func,
	item: PropTypes.object,
};

export default AddEditActivity;
